const LineToolIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  const size = "24px";

  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="4.38478"
        y1="13.1503"
        x2="13.3463"
        y2="4.18874"
        stroke={finalColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="14.0513" cy="3.875" r="1" fill={finalColor} />
      <circle cx="4.05128" cy="13.875" r="1" fill={finalColor} />
    </svg>
  );
};

export default LineToolIcon;
